var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mt-4"},[_c('image-form',{attrs:{"element":_vm.element,"repos":_vm.repos}}),_c('duration-form',{attrs:{"element":_vm.element}}),_c('pin-form',{attrs:{"element":_vm.element}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }